/**
 * Copyright (c) 2021 TechDivision GmbH
 * All rights reserved
 */

/**
 * @module ProductComparisonForm
 */
;(function ProductComparisonForm() {
    /**
     * handles the events for the product comparison form
     *
     * @constructor
     */
    function ProductComparisonForm() {
        let modal = document.querySelector('#comparisonModal')

        /**
         * initial check before running script
         */
        this.init = function () {
            if (modal) {
                this.handleModalState()
                this.preventMultipleFormSubmitting()
                this.setupDownloadSuccessActions()
            }
        }

        /**
         * open modal if form was sent before
         */
        this.handleModalState = function () {
            if (window.location.hash == '#comparison-form') {
                $(modal).modal('toggle')
            }
        }

        /**
         * prevent double submitting of form data TODO listen on success var
         */
        this.preventMultipleFormSubmitting = function () {
            if (window.history.replaceState) {
                window.history.replaceState(null, null, window.location.href)
            }
        }

        /**
         * Handles the download buttons for the comparison:
         * By using the data-success attribute the 'new search' and the 'direct download' buttons are activated,
         * if the download form was sent successfully
         * The 'new download' button was necessary to reload the page to reset the form for new colors or products
         */
        this.setupDownloadSuccessActions = function () {
            if (window.comparisonDownloadLink !== undefined) {
                $('.js-comparison__actions').attr('data-success', true)
                $('.js-comparison__download').attr('href', window.comparisonDownloadLink)
            }
        }

        /**
         * initialize call
         */
        this.init()
    }

    // define the global scope
    if (!window.Creaton) {
        window.Creaton = {}
    }

    window.Creaton.ProductComparisonForm = ProductComparisonForm
})()

function pageReady(fn) {
    if (document.readyState !== 'loading') {
        fn()
    } else if (document.addEventListener) {
        document.addEventListener('DOMContentLoaded', fn)
    } else {
        document.attachEvent('onreadystatechange', function () {
            if (document.readyState !== 'loading') fn()
        })
    }
}

function initProductComparisonForm() {
    new window.Creaton.ProductComparisonForm()
}

pageReady(initProductComparisonForm)
